import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import createInfo from "./CouponCode.module.css";
import Select from "react-select";
import { customStyles } from "../../../../../pages/customStyles";
import { AxiosInstance } from "../../../../../axios";
import { ImageUrlPrefix } from "../../../../../labels";
import { Download } from "@mui/icons-material";
import Creatable from "react-select/creatable";
import toast from "react-hot-toast";
import Loader from "../../../Loader";
import moment from "moment";
import DatePickerSample from "../../../DatePicker";
export default function CouponInfoCreate() {
  const { id } = useParams();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  const navigate = useNavigate();
  const [ccategory, setCcategory] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [groupName, setGroupName] = useState();
  const [applicableCategories, setApplicableCategories] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [initialfields, setInitialfields] = useState({
    Title: "",
    CouponAmount: "",
    emailIds: [],
    emailLabel: [],
    userIds: [],
    newEmails: [],
    FDate: "",
    TDate: "",
    status: 1,
    batchSelection: 0,
    batch_name: "",
    batch_id: "",
    courseGrouping: ""
  });

  const [removedValues, setRemovedValues] = useState([]);

  const [appBatch, setAppBatch] = useState([]);

  const [error, setError] = useState({});
  const [status, setStatus] = useState([]);

  const [appBatchse, setAppBatchse] = useState([]);


  useEffect(() => {
    setSelectedBatch({
      value: appBatchse.value > 0 ? appBatchse.value : initialfields.batch_id || "",
      label: appBatchse.value > 0 ? appBatchse.label : initialfields.batch_name || "",
    });
  }, [appBatchse, initialfields.batch_name, initialfields.batch_id]);
  const [selectedBatch, setSelectedBatch] = useState({
    value: appBatchse.value > 0 ? appBatchse.value : initialfields.batch_id || "",
    label: appBatchse.value > 0 ? appBatchse.label : initialfields.batch_name || "",
  });

  useEffect(() => {
    const emailList = { search: searchText };
    AxiosInstance.post("/api/all/coupon/dropdown", emailList)
      .then((res) => {
        const options = res.data?.data?.map((item) => ({
          value: item.id,
          label: item.email,
          user_id: item.user_id,
        }));
        setAllCategories(options);
      })
      .catch((error) => console.error(error));
  }, [searchText]);
  let tempstatusnum = [];
  useEffect(() => {
    let tempstatusnum = [];
    let tempstatus = [];

    status.map((obj) => {
      tempstatus.push(obj.id);
    });
    tempstatusnum = tempstatus.map(Number);
    let statusFilter = {
      // category: "",
      status: [parseInt(initialfields.status)],
      batch_type: "",
      medium: "",
      class_mode: "",
      start_date: "",
      end_date: "",
      c_start_date: "",
      c_end_date: "",
      start_time: "",
      end_time: "",
      search: "",
      type: "",
      location: "",
    };
    AxiosInstance.post("api/batch/list", statusFilter)
      .then((res) => {

        if (res.data.status === true) {
          if (res.data.data.length > 0) {
            const Apbatch = res.data.data.map((item, index) => ({
              medium: item.medium,
              value: item.id,
              label: `${item.name} - ( ${item.section} -${item.medium} - ${item.class_mode})`,
              // label: `${item.batch_name} - (${item.medium})`,
              batch_pk: item.id,
              batch_name: item.batch_name,
              class_mode: item.class_mode,
              section: item.section,
              // category: item.category,
              // category_class: item.category_class,
              // category_course_id: item.category_course_id,
            }));
            setAppBatch(Apbatch);
          }
        } else {
          setAppBatch([]);
        }
      })
      .catch((error) => {
        return error;
      });
  }, [initialfields.status]);
  // const handlechangeSelectDropdown = (selectedOptions, dname) => {
  //   if (dname === "emailIds") {
  //     const ids = selectedOptions?.map((option) => option.value) || [];
  //     const labels = selectedOptions?.map((option) => option.label) || [];
  //     const userIds = selectedOptions?.map((option) => option.user_id || null) || [];

  //     // Determine new emails
  //   const newEmails = selectedOptions?.filter(option => !initialfields.emailIds.includes(option.value)) || [];
  //   const modifiedNewEmails = newEmails.map(option => ({
  //     ...option,
  //     id: "", // Set id to empty string for new emails
  //   }));
  //     const prevIds = initialfields.emailIds || [];
  //     const removed = prevIds.filter((id) => !ids.includes(id));
  //     // const removed = initialfields.emailIds.filter((prevId) => !ids.includes(prevId));
  //     setRemovedValues((prev) => [...prev, ...removed]);
  //     setInitialfields((prevState) => ({
  //       ...prevState,
  //       [dname]: ids,
  //       ["emailLabel"]: labels,
  //       ["userIds"]: userIds.filter((id) => id !== null),
  //       newEmails: modifiedNewEmails,
  //     }));
  //     setError((prevState) => ({
  //       ...prevState,
  //       [dname]: "",
  //     }));
  //   }
  // };

  const handlechangeSelectDropdown = (selectedOptions, dname) => {

    if (dname === "emailIds") {
      const ids = selectedOptions?.map((option) => option.value) || [];
      const labels = selectedOptions?.map((option) => option.label) || [];
      const userIds =
        selectedOptions?.map((option) => option.user_id || null) || [];

      // Identify new emails by checking if their ID is not already in emailIds
      const newEmails = selectedOptions.filter(
        (option) => !initialfields.emailIds.includes(option.value)
      );

      const modifiedNewEmails = newEmails.map((option) => ({
        ...option,
        id: "", // Assign empty string for new emails
      }));

      // Track removed values for unselected emails
      const prevIds = initialfields.emailIds || [];
      const removed = prevIds.filter((id) => !ids.includes(id));

      // Add the new emails to the state
      setRemovedValues((prev) => [...prev, ...removed]);
      setInitialfields((prevState) => ({
        ...prevState,
        [dname]: ids,
        emailLabel: labels,
        userIds: userIds.filter((id) => id !== null),
        newEmails: [...(prevState.newEmails || []), ...modifiedNewEmails], // Ensure newEmails is an array
      }));

      // Log the modified new emails

      setError((prevState) => ({
        ...prevState,
        [dname]: "",
      }));
    }
    else if (dname === "AppBatch") {
      const selectedAppBatch = {
        value: selectedOptions.value,
        label: selectedOptions.label,
        batch_pk: selectedOptions.batch_pk,
        batch_name: selectedOptions.label,
        section: selectedOptions.section,
        // category: selectedOptions.category,
        // category_class: selectedOptions.category_class,
        // category_course_id: selectedOptions.category_course_id,
      };

      setAppBatchse(selectedAppBatch);
      setError((prevError) => ({
        ...prevError,
        [appBatch]: "",
      }));
    }
  };
  const handleInputChange = (newValue) => {
    setSearchText(newValue); // Update search text state
  };

  const handleChange = (event) => {
    const { name, files, value } = event.target;
    if (name === "status") {
      setSelectedBatch({});

    }
    if (name === "batchSelection") {
      setSelectedBatch({});
      setInitialfields((prev) => ({
        ...prev,
        emailIds: [],
        emailLabel: []
      }))
    }
    if (name === "CouponAmount") {
      if (value < 0) return;
    }
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,

    }));
    setError({
      ...error,
      [name]: "",
    });

  };

  // Ref
  const course_ref = useRef(null);
  const batch_ref = useRef(null);
  const type_of_admission_ref = useRef(null);
  const category_ref = useRef(null);
  const sub_category_ref = useRef(null);
  const sub_category_refssss = useRef(null);

  // Validation error
  const validateFields = (data) => {
    const errors = {};
    console.log(errors, "errors____", initialfields.batchSelection);

    if (!data.Title) {
      errors.Title = "Please enter the title";
    }

    if (!data.CouponAmount) {
      errors.CouponAmount = "Please enter the amount";
    }
    if (!data.FDate) {
      errors.FDate = "Please select Valid From date";
    }
    if (!data.TDate) {
      errors.TDate = "Please select Valid To date";
    }
    if ((!selectedBatch || !selectedBatch.value) && initialfields.batchSelection != 0) {
      errors.courseGrouping = "Please select batch name";
    }

    // if (data.emailIds === "") {
    //   errors.emailIds = "Please select atleast one email id";
    // }
    if (!Array.isArray(data.emailIds) || data.emailIds.length === 0 && initialfields.batchSelection != 1) {
      errors.emailIds = "Please select at least one email ID";
    }
    validateFocusCommentSection(data);
    return errors;
  };

  // focus the error fields in comment section
  const validateFocusCommentSection = (COMSECFO) => {
    console.log(COMSECFO, "COMSECFO_____");

    if (!COMSECFO.Title) {
      course_ref.current.focus();
    } else if (!COMSECFO.CouponAmount) {
      type_of_admission_ref.current.focus();
    } else if (!COMSECFO.emailIds) {
      category_ref.current.focus();
    } else if (!COMSECFO.FDate) {
      sub_category_ref.current.focus();
    } else if (!COMSECFO.FDate) {
      sub_category_refssss.current.focus();
    }
    //  else if (!COMSECFO.courseGrouping) {
    //   batch_ref.current.focus();
    // }
  };
  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/all/coupon/findbyId", { id: parseInt(id) })
      .then((res) => {
        if (res.data.status === true) {
          setInitialfields({
            Title: res.data.coupon_data[0].title,
            coupon_code: res.data.coupon_data[0].coupon_code,
            CouponAmount: res.data.coupon_data[0].amount,
            batch_id: res.data.coupon_data[0].batch_id,
            batch_name: res.data.coupon_data[0].batch_name,
            batchSelection: res.data.coupon_data[0].batch_selection,
            status: res.data.coupon_data[0].batch_status,
            FDate: moment(res.data.coupon_data[0].start_date).format(
              "YYYY-MM-DD"
            ),
            TDate: moment(res.data.coupon_data[0].end_date).format(
              "YYYY-MM-DD"
            ),
            emailIds: res.data.applicable_users.map((item) => item.id),
            emailLabel: res.data.applicable_users.map((item) => item.email),
            userIds: res.data.applicable_users.map((item) => item.user_id),
          });
          const transformedOptions = res.data.applicable_users.map((user) => ({
            value: user.id,
            label: user.email,
            user_id: user.user_id,
          }));
          setApplicableCategories(transformedOptions);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  }, [id]);

  const handleSubmit = () => {
    const err_bnh = validateFields(initialfields);
    if (moment(initialfields.FDate).isAfter(moment(initialfields.TDate))) {
      err_bnh.FDate = "Valid From date cannot be later than Valid To date";
      err_bnh.TDate = "Valid To date cannot be earlier than Valid From date";
    }
    if (Object.keys(err_bnh).length === 0) {
      try {

        if (id) {
          // Combine all user entries
          const newEmails = initialfields?.newEmails || [];
          let user = [
            ...initialfields?.emailIds.map((emailId, index) => ({
              id: emailId,
              user_id: initialfields.userIds[index],
              is_valid: 1,
            })),
            ...removedValues?.map((removedId, index) => ({
              id: removedId,
              user_id: initialfields.userIds[index],
              is_valid: 0,
            })),
            ...newEmails?.map((newEmail) => ({
              id: newEmail.id || "",
              user_id: newEmail.user_id,
              is_valid: 1,
            })),
          ];
          // Deduplicate entries by user_id
          const uniqueUsers = user.reduce((acc, current) => {
            const existingIndex = acc.findIndex(
              (item) => item.user_id === current.user_id
            );
            if (existingIndex > -1) {
              acc[existingIndex] = current; // Replace with the latest entry
            } else {
              acc.push(current);
            }
            return acc;
          }, []);

          const updateCoupon = {
            id: id,
            coupon_title: initialfields.Title,
            amount: initialfields.CouponAmount,
            start_date: initialfields.FDate,
            end_date: initialfields.TDate,
            is_deleted: 0,
            created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
            created_by: userid,
            is_deleted: 0,
            batch_status: initialfields.status,
            batch_selection: initialfields.batchSelection,
            users: uniqueUsers.length == 0 ? [] : uniqueUsers,
            batch_id: initialfields.batchSelection == 0 ? 0 : selectedBatch.value
          };

          AxiosInstance.post(`api/all/coupon/add`, updateCoupon)
            .then((res) => {
              console.log(res, "resresres____");

              if (res.data.status) {
                toast.success(res.data.message);
                navigate("/ListCouponCode");
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          const users = initialfields.emailIds.map((emailId, index) => ({
            id: emailId,
            user_id: initialfields.userIds[index],
            is_valid: 1,
          }));

          const updateCoupon = {
            id: "", // If edit coupon , Id value is must.
            coupon_title: initialfields.Title,
            amount: initialfields.CouponAmount,
            start_date: initialfields.FDate,
            end_date: initialfields.TDate,
            is_deleted: 0,
            batch_status: initialfields.status,
            is_deleted: 0,
            batch_selection: initialfields.batchSelection,
            created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
            created_by: userid,
            users: users.length == 0 ? [] : users,
            batch_id: initialfields.batchSelection == 0 ? 0 : selectedBatch.value
          };

          AxiosInstance.post(`api/all/coupon/add`, updateCoupon)
            .then((res) => {
              if (res.data.status) {
                toast.success(res.data.message);
                navigate("/ListCouponCode");
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              return error;
            });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(err_bnh);
    }
  };

  const navigateToPreviousScreen = () => {
    navigate(-1); // Navigate back by one step in the history
  };

  const handleDateChange = (date, name) => {
    const dateDOB = moment(date).format("YYYY-MM-DD");
    if (!date) {
      return;
    }
    setError((prev) => ({
      ...prev,
      [name]: "",
    }));
    if (name === "FDate" || name === "TDate") {
      const from = name === "FDate" ? dateDOB : initialfields.FDate;
      const to = name === "TDate" ? dateDOB : initialfields.TDate;

      if (name === "TDate" && moment(to).isBefore(moment(from))) {
        setInitialfields({
          ...initialfields,
          [name]: dateDOB,
        });
        setError((prev) => ({
          ...prev,
          TDate: "Valid To date cannot be earlier than Valid From date",
        }));
        return;
      }
      if (name === "FDate" && moment(from).isAfter(moment(to)) && to) {
        setInitialfields({
          ...initialfields,
          [name]: dateDOB,
        });
        setError((prev) => ({
          ...prev,
          FDate: "Valid From date cannot be later than Valid To date",
        }));
        return;
      }
    }
    setInitialfields({
      ...initialfields,
      [name]: dateDOB,
    });
  };
  const futureDate = moment().add(0, "days");
  const custom_styles = {
    control: (provided) => ({
      ...provided,
      fontSize: "14px",
      minHeight: "36px",
      borderColor: "#ccc",
      boxShadow: "none",
      "&:hover": { borderColor: "#aaa" },
    }),
    option: (provided, { isFocused, isSelected }) => ({
      ...provided,
      backgroundColor: isSelected
        ? "#4CAF50" // Change selected background color
        : isFocused
          ? "#f0f0f0" // Change hover color
          : "white",
      color: isSelected ? "white" : "black",
      cursor: "pointer",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#aaa", // Lighter placeholder color
      fontStyle: "italic",
    }),
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`${createInfo.CourseInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">
            {id ? "Edit Coupon Code" : "Create New Coupon Code"}
          </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/ListCouponCode"}
                onClick={id ? navigateToPreviousScreen : () => { }}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View Coupon Code" : "Back to Coupon Codes"}
              </Link>
            </li>
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center "
                variant="primary"
              >
                Save Coupon Code
              </Link>
            </li>
          </ul>
        </div>
        <div className="row m-0 mb-4">
          <fieldset className="mt-3">
            <legend className="w-auto">Coupon Details</legend>
            <form className="row g-3">
              <div class="col-md-6">
                <label for="Title" class="form-label confirm_value ">
                  Title
                </label>
                <input
                  ref={course_ref}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm`} //new style added
                  type="text"
                  id="Title"
                  name="Title"
                  maxLength={150}
                  placeholder="Enter the title"
                  value={initialfields.Title}
                  onChange={handleChange}
                />
                {error.Title && (
                  <small className="error_message">{error.Title}</small>
                )}
              </div>
              <div class="col-md-6">
                <label for="CouponAmount" class="form-label confirm_value ">
                  Amount
                </label>
                <input
                  ref={type_of_admission_ref}
                  class={`desc_input_text w-100 rounded-2 input-font-size-sm
                    `}
                  // isDisabled={id ? true : false}
                  type="number"
                  id="CouponAmount"
                  name="CouponAmount"
                  placeholder="Enter the amount"
                  value={initialfields.CouponAmount}
                  onChange={handleChange}
                />
                {error.CouponAmount && (
                  <small className="error_message">{error.CouponAmount}</small>
                )}
              </div>
              <div className="col-md-6">
                <label htmlFor="FDate" class="form-label confirm_value">
                  Valid From
                </label>

                <DatePickerSample
                  txtAdMDob={sub_category_ref}
                  className={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                  name={"FDate"}
                  handleChange={(date) => handleDateChange(date, "FDate")}
                  // fieldInput={`${moment(initialfields.FDate).format("DD/MM/YYYY")}`}
                  fieldInput={
                    initialfields.FDate
                      ? moment(initialfields.FDate).format("DD/MM/YYYY")
                      : ""
                  }
                  minDate={futureDate}
                />

                {error.FDate && (
                  <small className="error_message">{error.FDate}</small>
                )}
              </div>
              {/* -------Range To ---------- */}
              <div className="col-md-6">
                <div className="forms ">
                  <label htmlFor="range" class="form-label confirm_value">
                    Valid To
                  </label>

                  <DatePickerSample
                    txtAdMDob={sub_category_refssss}
                    name={"TDate"}
                    handleChange={(date) => handleDateChange(date, "TDate")}
                    // fieldInput={`${moment(initialfields.TDate).format("DD/MM/YYYY")}`}
                    fieldInput={
                      initialfields.TDate
                        ? moment(initialfields.TDate).format("DD/MM/YYYY")
                        : ""
                    }
                    minDate={futureDate}
                  />
                  {error.TDate && (
                    <small className="error_message">{error.TDate}</small>
                  )}
                </div>
              </div>

            </form>
          </fieldset>
          <fieldset className="mt-3">
            <legend className="w-auto">Batch Details</legend>
            <form className="row g-3">
              <div className="col-md-6">
                <label htmlFor="ebook" className="form-label confirm_value">
                  Eligible Users
                </label>
                <div>
                  <input
                    // ref={ebook_ref}
                    className={`shadow-none input-font-size  ${createInfo.checkbox_radio} ${!!id && initialfields.batchSelection == 1 ? "disabled_btn" : ""}`}

                    disabled={!!id && initialfields.batchSelection == 1}
                    type="radio"
                    checked={initialfields.batchSelection == 0 ? true : false}
                    id="yes"
                    name="batchSelection"
                    value={0}
                    onChange={handleChange}
                  />
                  <label
                    htmlFor="yes"
                    className={`${createInfo.margin_right} form-label confirm_value ${!!id && initialfields.batchSelection == 1 ? "disabled_btn" : ""}`}
                  >
                    For Individual
                  </label>

                  <input
                    // ref={ebook_ref}
                    className={`shadow-none input-font-size  ${createInfo.checkbox_radio} ${!!id && initialfields.batchSelection == 0 ? "disabled_btn" : ""}`}
                    // isDisabled={initialfields.batchSelection > 0 ? true : false}
                    disabled={!!id && initialfields.batchSelection == 0}

                    type="radio"
                    id="no"
                    name="batchSelection"
                    value={1}
                    checked={initialfields.batchSelection == 1 || initialfields.batchSelection > 0}
                    onChange={handleChange}
                  />
                  <label htmlFor="no" className={`form-label confirm_value ${!!id && initialfields.batchSelection == 0 ? "disabled_btn" : ""}`}>
                    For Entire Batch
                  </label>
                </div>
                {error.batchSelection && (
                  <small className="error_message">{error.batchSelection}</small>
                )}
              </div>
              {initialfields.batchSelection == 1 && (
                <>
                  <div className="col-md-6">
                    <label htmlFor="ebook" className="form-label confirm_value">
                      Batch Status
                    </label>

                    <div>
                      <input
                        className={`shadow-none input-font-size  ${createInfo.checkbox_radio}`}
                        disabled={!!id && initialfields.batchSelection == 1}
                        type="radio"
                        checked={initialfields.status == 1 ? true : false}
                        id="Ongoing"
                        name="status"
                        value={1}
                        onChange={handleChange}
                      />
                      <label
                        htmlFor="Ongoing"
                        className={` ${!!id && initialfields.batchSelection == 1 ? "disabled_btn" : ""}  ${createInfo.margin_right} form-label confirm_value`}
                      >
                        Ongoing
                      </label>

                      <input
                        className={`shadow-none input-font-size  ${createInfo.checkbox_radio}`}
                        type="radio"
                        id="Completed"
                        name="status"
                        value={0}
                        checked={initialfields.status == 0 ? true : false}
                        onChange={handleChange}
                        disabled={!!id && initialfields.batchSelection == 1}
                      />
                      <label htmlFor="Completed" className={`${!!id && initialfields.batchSelection == 1 ? "disabled_btn" : ""} form-label confirm_value`}>
                        Completed
                      </label>
                    </div>
                    {error.ebook && (
                      <small className="error_message">{error.ebook}</small>
                    )}
                  </div>

                  <div className="col-md-6">
                    <label for="courseGrouping" class="form-label confirm_value ">
                      Batch Name
                    </label>
                    <Select
                      ref={batch_ref}
                      isDisabled={!!id && initialfields.batchSelection == 1}
                      className="shadow-none input-font-size"
                      name="courseGrouping"
                      value={selectedBatch?.value ? selectedBatch : ""}
                      onChange={(selectedOptions) => {
                        setSelectedBatch(selectedOptions);
                        handlechangeSelectDropdown(selectedOptions, "AppBatch");
                      }}
                      options={appBatch
                        .filter((item) => item && item.label)
                        .sort((a, b) => a.label.localeCompare(b.label))}
                      isSearchable={true}
                      placeholder="Select Batch"
                      maxMenuHeight={200}
                      filterOption={(option, searchText) =>
                        option.label.toLowerCase().includes(searchText.toLowerCase())
                      }
                      styles={customStyles}
                    />


                    {error.courseGrouping && (
                      <small className="error_message">{error.courseGrouping}</small>
                    )}
                  </div>
                </>

              )}

            </form>
          </fieldset>
          {initialfields.batchSelection == 0 && (
            <fieldset className="mt-3">
              <legend className="w-auto">Emails</legend>
              <form className="row g-3">

                <div className="col-md-12">
                  <label
                    for="emailIds"
                    class="form-label confirm_value"
                  // class={
                  //   id
                  //     ? "form-label confirm_value disabled_btn"
                  //     : "form-label confirm_value "
                  // }
                  >
                    Email IDs
                  </label>
                  {/* <Select
        ref={category_ref}
        className={`shadow-none input-font-size ${id ? "disabled_btn" : ""
          }`}
        isDisabled={id ? true : false}
        name="emailIds"
        value={
          initialfields.emailLabel !== null &&
            initialfields.emailIds !== ""
            ? {
              value: initialfields.emailIds,
              label: initialfields.emailLabel,
            }
            : null
        }
        onChange={(option) =>
          handlechangeSelectDropdown(option, "emailIds")
        }
        options={ccategory}
        isSearchable={true} // Enables search functionality
        placeholder="Select email ids"
        maxMenuHeight={200} // Set a maximum height for the dropdown menu maxium 5
        filterOption={(option, searchText) =>
          option.label
            .toLowerCase()
            .includes(searchText.toLowerCase())
        } // Filter options based on the search text
        styles={customStyles} // Apply custom styles her
      /> */}
                  <Select
                    ref={category_ref}
                    className={`shadow-none input-font-size `}
                    name="emailIds"
                    value={
                      Array.isArray(initialfields.emailIds) &&
                        initialfields.emailIds.length > 0
                        ? initialfields.emailIds.map((id, index) => ({
                          value: id,
                          label: initialfields.emailLabel[index],
                          user_id: initialfields.userIds[index],
                        }))
                        : []
                    }
                    onChange={(selectedOptions) =>
                      handlechangeSelectDropdown(selectedOptions, "emailIds")
                    }
                    onInputChange={handleInputChange}
                    // options={allCategories}
                    options={allCategories?.filter(
                      (option) => !initialfields.userIds.includes(option.user_id)
                    )}
                    isMulti
                    isSearchable={true}
                    placeholder="Select email ids"
                    maxMenuHeight={200}
                    filterOption={(option, searchText) =>
                      option.label
                        ?.toLowerCase()
                        .includes(searchText?.toLowerCase())
                    }
                    styles={customStyles}
                  />
                  {error.emailIds && (
                    <small className="error_message">{error.emailIds}</small>
                  )}
                </div>
              </form>
            </fieldset>
          )}

        </div>
        <div className="col-md-12 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/ListCouponCode"}
                onClick={id ? navigateToPreviousScreen : () => { }}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to View Coupon Code" : "Back to Coupon Codes"}
              </Link>
            </li>
            <li class="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center "
                variant="primary"
              >
                Save Coupon Code
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
